import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { IconCtaBordered } from '@ahc-digital/component-library';
import { CreateIconCTABorderedModel } from './C31IconCTABordered.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import {
  RenderingProps,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
} from 'src/shared/shared.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C31IconCTABorderedProps = RenderingProps<
  C31IconCTABorderedFields,
  {
    TitleType?: string;
    NumberOfColumns?: string;
  } & DynamicPlaceholderParams &
    TranslationOptionsParams &
    AnchorTargetParams
>;
export type C31IconCTABorderedFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  BottomSupportCopy?: RichTextField;
};

export const Default = (props?: C31IconCTABorderedProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <IconCtaBordered
      {...CreateIconCTABorderedModel(props)}
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
    />
  );
};
